export const appLocale = 'pl-PL';
